import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch } from "~/hooks/reduxHooks";
import { toggleProfilePanel } from "~/store/layoutSlice";

const OpenProfileRedirect = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(toggleProfilePanel());
		navigate("/", { replace: true });
	}, []);

	return null;
};

export default OpenProfileRedirect;
